<template>
  <a-card :bordered="false">
    <div class="">
      <span>
        <span style="width: 100px;display: inline-block"> H5注册地址:</span>
        <span>{{ url }}</span>
          <a
            style="margin-left: 60px"
            v-clipboard:copy="url"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >复制</a>
      </span>
      <div class="code-box">
        <div class="title"> 注册二维码:</div>
        <img :src="codeUrl"/>
        <div class="tips-box">
          <span>下载并邀请注册二维码</span>
          <br>
          <span>引导更多成员参与分销</span>
          <br>
          <a-select style="width:140px;margin-top: 10px;margin-bottom: 10px;" v-model="codeWidth">
            <a-select-option :value="250">250</a-select-option>
            <a-select-option :value="500">500</a-select-option>
            <a-select-option :value="1200">1200</a-select-option>
          </a-select>
          <br>
          <a @click="downloadCode()">下载二维码</a>
        </div>
      </div>
    </div>
  </a-card>
</template>

<script>
import downLoadHelper from '../../../utils/helper/downLoadHelper'

export default {
  name: 'InvitationalPortComponent',
  data() {
    return {
      url: '',
      codeUrl: '',
      codeWidth: 250
    }
  },
  watch: {
    codeWidth: function(value) {
      this.codeUrl = this.getCodeUrl(value)
    }
  },
  mounted() {
    this.codeUrl = this.getCodeUrl(this.codeWidth)
    this.getDetails()
  },
  methods: {
    getCodeUrl(width) {
      const merchantId = this.$store.getters.userInfo.merchantId
      return this.getAppConfig().userUrl + 'staff/v2/getStaffInvited?merchantId=' + merchantId + '&size=' + width
    },
    downloadCode() {
      downLoadHelper.downloadImage('download.png', this.codeUrl)
    },
    getDetails() {
      this.getHttpServices().getUserService().post('staff/v2/getStaffInvitedUrl')
        .then(url => {
          this.url = url
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onCopy(e) {
      this.$message.success('复制成功')
    },
    onError(e) {
      this.$message.error('移除失败')
    }
  }

}
</script>
<style scoped lang="less">
.code-box {
  margin-top: 20px;
  position: relative;
  height: 90px;

  .title {
    width: 100px;
    position: absolute;
    top: 0;
    left: 0;
  }

  img {
    position: absolute;
    top: 0;
    left: 100px;
    height: 90px;
    width: 90px;
  }

  .tips-box {
    position: absolute;
    left: 200px;
    top: 0;
  }

}
</style>